// Human labels for an order's approval flags (Order.approvalReason, comma-joined codes).
const REASON_LABEL = {
  manual_review: 'Standard review',
  new_client: 'New client',
  over_ceiling: 'Over value ceiling',
  account_on_hold: 'Account on hold',
  over_credit_limit: 'Over credit limit',
  auto: 'Auto',
};
export const approvalReasons = (codes) =>
  String(codes || '')
    .split(',')
    .map((c) => c.trim())
    .filter(Boolean)
    .map((c) => ({ code: c, label: REASON_LABEL[c] || c.replace(/_/g, ' '), credit: c === 'account_on_hold' || c === 'over_credit_limit' }));
export const approvalReasonText = (codes) => approvalReasons(codes).map((r) => r.label).join(', ');
